import { AppTheme, AppThemeManager } from "./AppThemeManager";

export const activateSharedUXDarkMode = () => {
  // Load Dark Theme to the UI
  AppThemeManager.getInstance().loadTheme(AppTheme.Dark);
  // Add Dark Icons classname
  document.body.className = document.body.className + " UxDarkMode";
};

export const deactivateSharedUXDarkMode = () => {
  // Load Light Theme to the UI
  AppThemeManager.getInstance().loadTheme(AppTheme.Light);
  // Remove Dark Icons classname
  document.body.className = document.body.className.replace(" UxDarkMode", "");
};

// Exported function that allows the shared UX to toggle between Light and Dark mode
export const toggleSharedUXDarkMode = () => {
  let appThemeManager = AppThemeManager.getInstance();
  if (appThemeManager.getThemeMode() === AppTheme.Light) {
    activateSharedUXDarkMode();
  } else if (appThemeManager.getThemeMode() === AppTheme.Dark) {
    deactivateSharedUXDarkMode();
  }
};

export const isSharedUXDarkModeOn = () => {
  return AppThemeManager.getInstance().getThemeMode() === AppTheme.Dark;
};
